import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = { class: "flex w-full flex-col" }
const _hoisted_3 = { class: "text-sm font-semibold text-gray-600" }
const _hoisted_4 = { class: "text-[10px] text-gray-500" }
const _hoisted_5 = ["name", "disabled"]

import { computed } from 'vue';
import { CloudUploadIcon, XIcon } from '@heroicons/vue/outline';
import { ErrorObject } from '@vuelidate/core';

// v-model binding for `file`

export default /*@__PURE__*/_defineComponent({
  __name: 'UiAudioUpload',
  props: /*@__PURE__*/_mergeModels({
    name: String,
    disabled: { type: Boolean, default: false },
    textRule: String,
    errors: { type: Array as () => ErrorObject[], default: () => [] },
    silentErrors: { type: Array as () => ErrorObject[], default: () => [] },
}, {
    "file": {},
    "fileModifiers": {},
  }),
  emits: ["update:file"],
  setup(__props) {

const file = _useModel<File | null>(__props, 'file');

const props = __props;

function handleAudioUpload(event: Event) {
    const input = event.target as HTMLInputElement;
    file.value = input.files?.[0] || null;
}

function removeFile() {
    file.value = null;
}

const hasErrors = computed(() => props.errors.length > 0 || props.silentErrors.length > 0);

const disabledClass = computed(() =>
    props.disabled ? 'bg-gray-200 text-gray-400 cursor-not-allowed' : 'bg-white',
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["relative flex w-full items-center gap-3 rounded border-0 p-3 text-gray-800 shadow ring-1 ring-inset transition", [
            disabledClass.value,
            hasErrors.value ? 'ring-danger focus:ring-danger' : 'focus:ring-primary ring-gray-300',
        ]])
  }, [
    _createElementVNode("label", {
      for: props.name,
      class: _normalizeClass(["flex flex-1 cursor-pointer items-center gap-4", props.disabled && 'cursor-not-allowed'])
    }, [
      _createVNode(_unref(CloudUploadIcon), { class: "h-8 w-8 text-gray-300" }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(file.value?.name || _ctx.$t('connectFlowAudio.create.fileLabel')), 1),
        _createElementVNode("span", _hoisted_4, _toDisplayString(props.textRule), 1)
      ]),
      _createElementVNode("input", {
        onChange: handleAudioUpload,
        name: props.name,
        type: "file",
        disabled: props.disabled,
        class: "sr-only"
      }, null, 40, _hoisted_5)
    ], 10, _hoisted_1),
    (file.value && !props.disabled)
      ? (_openBlock(), _createBlock(_unref(XIcon), {
          key: 0,
          class: "h-5 w-5 cursor-pointer text-gray-400 transition hover:text-red-500",
          onClick: removeFile
        }))
      : _createCommentVNode("", true)
  ], 2))
}
}

})